import React from 'react';
import './style.css';

const Information = () => {
  return <h1>Information</h1>;
};

export default Information;
